<template>
  <div>
    <!-- Prize Contents -->
    <div
      class="row flex-row flex-nowrap justify-content-center"
      style="overflow-x: hidden"
    >
      <!-- Left Side Card 
      <div class="card shadow customs-card mx-2">
        <div class="card-header border-0 py-2 mt-4 background-card">
          <p class="text-center mb-0 font-weight-bold headline text-white">|</p>
        </div>
      </div>-->

      <!-- Content Card -->
      <div class="card shadow customs-card mx-2">
        <!-- Win Campaign Label -->
        <div class="card-header border-0 py-2 mt-4 background-card">
          <p class="text-center mb-0 font-weight-bold headline text-white">
            アタリ済みキャンペーン
          </p>
        </div>

        <!-- Prize -->
        <div class="card-body p-4 d-flex align-items-center justify-content-center">
          <!-- Campaign Image -->
          <div class="row">
            <div class="col-10 p-0 mx-auto">
              <img
                :src="prize.imageUrl"
                :alt="Prize"
                class="img-fluid mx-auto d-block"
              />
            </div>
          </div>
        </div>

        <div class="card-footer border-0 mb-4">
          <!-- Prize Label -->
          <p class="m-0 mb-1 text-center font-weight-bold text-bold text-color" style="word-wrap:break-word" v-html="prize.campaign_name">
            <!--{{ prize.campaign_name }}-->
          </p>

          <!-- Campaign Description -->
          <p class="m-0 text-center text text-color">
            <span style="word-wrap:break-word" v-html="prize.name"></span>
            <!--{{ prize.name }}-->
          </p>

          <p class="text-center mb-0 text text-color">
            応募日 : {{ formatDate(prize.date) }}
          </p>
        </div>

        <div
            @click="handleReceiving()"
            class="shadow w-100"
            style="border-radius: 1rem"
            role="button"
          >
          <div
            class="card-footer border-0 background-danger"
            style="
              border-bottom-left-radius: 1rem;
              border-bottom-right-radius: 1rem;
            "
          >
            <p class="text-center mb-0 font-weight-bold headline text-white">
              ギフトを受け取る <i class="ml-2 ti-angle-right"></i>
            </p>
          </div>
        </div>
      </div>

      <!-- Right Side Card
      <div class="card shadow customs-card mx-2">
        <div class="card-header border-0 py-2 mt-4 background-card">
          <p class="text-center mb-0 font-weight-bold headline text-white">|</p>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import { getPrize } from "@/utils/campaign";
import Cautions from "@/components/Cautions.vue";

export default {
  components: {
    Cautions,
  },
  data() {
    return {
      prize: {
        campaign_name: "",
        name: "",
        imageUrl: "",
        type: 0,
        date: "",
        google_form: null,
        code: null,
        externalUrl : "",
      },
      cautions: "",
    };
  },
  beforeRouteEnter(to, from, next) {
    if (getPrize()) {
      next((vm) => {
        // set prize data
        vm.setPrizeData(getPrize());
      });
    } else {
      return next("/not-permission");
    }
  },
  methods: {
    setPrizeData(result) {
      this.prize.campaign_name = result.campaign_name || "";
      this.prize.name = result.name || "";
      this.prize.imageUrl = process.env.BASE_API + result.imageUrl;
      this.prize.type = result.type || 0;
      this.prize.date = result.date || "";
      this.prize.google_form = result.google_form || null;
      this.prize.code = result.code ? result.code : null;
      this.prize.externalUrl = result.externalUrl || "";
    },
    formatDate(date) {
      if (date.length > 0) {
        return date.substr(0, 10).replaceAll("-", ".");
      } else {
        return date;
      }
    },
    handleReceiving() {
      // check if prize is digital
      if (this.prize.code) {
        window.open(this.prize.externalUrl, "_blank");
      } else if (this.prize.google_form) {
        // open link in new tab
        window.open(this.prize.google_form, "_blank");
      }
    },
  },
};
</script>

<style scoped></style>
